import React from 'react';
import {
  useApi,
  identityApiRef,
  ProfileInfo,
} from '@backstage/core-plugin-api';

const UserSettings = () => {
  const identityApi = useApi(identityApiRef);
  const [profile, setProfile] = React.useState<ProfileInfo | null>(null);

  React.useEffect(() => {
    const fetchProfile = async () => {
      const userProfile = await identityApi.getProfileInfo();
      setProfile(userProfile);
    };

    fetchProfile();
  }, [identityApi]);

  window.gtag('set', 'user_properties', {
    namespace: profile ? profile.email?.split('@')[1] : null,
  });
  return <></>;
};

export default UserSettings;
